import i18n from '../i18n';

export const translate = (key: string, options?: i18n.TOptions) => {
  return i18n.t<string>(key, options);
};
